__turbopack_context__.v({
  "backLink": "RedesignRegisztracio-module__vyF8Qq__backLink",
  "benefitIcon": "RedesignRegisztracio-module__vyF8Qq__benefitIcon",
  "benefitItem": "RedesignRegisztracio-module__vyF8Qq__benefitItem",
  "benefitsList": "RedesignRegisztracio-module__vyF8Qq__benefitsList",
  "btnBack": "RedesignRegisztracio-module__vyF8Qq__btnBack",
  "btnNext": "RedesignRegisztracio-module__vyF8Qq__btnNext",
  "btnPrimary": "RedesignRegisztracio-module__vyF8Qq__btnPrimary",
  "btnRow": "RedesignRegisztracio-module__vyF8Qq__btnRow",
  "btnSubmit": "RedesignRegisztracio-module__vyF8Qq__btnSubmit",
  "consentBox": "RedesignRegisztracio-module__vyF8Qq__consentBox",
  "errorBox": "RedesignRegisztracio-module__vyF8Qq__errorBox",
  "eyebrowDark": "RedesignRegisztracio-module__vyF8Qq__eyebrowDark",
  "eyebrowDot": "RedesignRegisztracio-module__vyF8Qq__eyebrowDot",
  "fieldGroup": "RedesignRegisztracio-module__vyF8Qq__fieldGroup",
  "fieldRow": "RedesignRegisztracio-module__vyF8Qq__fieldRow",
  "formPanel": "RedesignRegisztracio-module__vyF8Qq__formPanel",
  "formSection": "RedesignRegisztracio-module__vyF8Qq__formSection",
  "formSub": "RedesignRegisztracio-module__vyF8Qq__formSub",
  "formTitle": "RedesignRegisztracio-module__vyF8Qq__formTitle",
  "gdprLabel": "RedesignRegisztracio-module__vyF8Qq__gdprLabel",
  "infoPanel": "RedesignRegisztracio-module__vyF8Qq__infoPanel",
  "infoSub": "RedesignRegisztracio-module__vyF8Qq__infoSub",
  "infoTitle": "RedesignRegisztracio-module__vyF8Qq__infoTitle",
  "input": "RedesignRegisztracio-module__vyF8Qq__input",
  "logoDot": "RedesignRegisztracio-module__vyF8Qq__logoDot",
  "logoIcon": "RedesignRegisztracio-module__vyF8Qq__logoIcon",
  "moduleCardName": "RedesignRegisztracio-module__vyF8Qq__moduleCardName",
  "moduleGrid": "RedesignRegisztracio-module__vyF8Qq__moduleGrid",
  "moduleSelectCard": "RedesignRegisztracio-module__vyF8Qq__moduleSelectCard",
  "navBar": "RedesignRegisztracio-module__vyF8Qq__navBar",
  "navLogo": "RedesignRegisztracio-module__vyF8Qq__navLogo",
  "pageBody": "RedesignRegisztracio-module__vyF8Qq__pageBody",
  "progLabel": "RedesignRegisztracio-module__vyF8Qq__progLabel",
  "progNum": "RedesignRegisztracio-module__vyF8Qq__progNum",
  "progStep": "RedesignRegisztracio-module__vyF8Qq__progStep",
  "progStepActive": "RedesignRegisztracio-module__vyF8Qq__progStepActive",
  "progStepDone": "RedesignRegisztracio-module__vyF8Qq__progStepDone",
  "progressBar": "RedesignRegisztracio-module__vyF8Qq__progressBar",
  "select": "RedesignRegisztracio-module__vyF8Qq__select",
  "site": "RedesignRegisztracio-module__vyF8Qq__site",
  "stepItem": "RedesignRegisztracio-module__vyF8Qq__stepItem",
  "stepNum": "RedesignRegisztracio-module__vyF8Qq__stepNum",
  "stepNumDone": "RedesignRegisztracio-module__vyF8Qq__stepNumDone",
  "stepText": "RedesignRegisztracio-module__vyF8Qq__stepText",
  "stepsList": "RedesignRegisztracio-module__vyF8Qq__stepsList",
  "stepsSection": "RedesignRegisztracio-module__vyF8Qq__stepsSection",
  "stepsTitle": "RedesignRegisztracio-module__vyF8Qq__stepsTitle",
  "success": "RedesignRegisztracio-module__vyF8Qq__success",
  "successIcon": "RedesignRegisztracio-module__vyF8Qq__successIcon",
  "successSub": "RedesignRegisztracio-module__vyF8Qq__successSub",
  "successTitle": "RedesignRegisztracio-module__vyF8Qq__successTitle",
  "summaryBlock": "RedesignRegisztracio-module__vyF8Qq__summaryBlock",
  "summaryKey": "RedesignRegisztracio-module__vyF8Qq__summaryKey",
  "summaryRow": "RedesignRegisztracio-module__vyF8Qq__summaryRow",
  "summaryTitle": "RedesignRegisztracio-module__vyF8Qq__summaryTitle",
  "summaryVal": "RedesignRegisztracio-module__vyF8Qq__summaryVal",
  "textarea": "RedesignRegisztracio-module__vyF8Qq__textarea",
});
